module.exports = __webpack_public_path__ + "static/media/point+10.253c99c6.png";